import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Alert,
  Link,
} from '@mui/material';
import styled from 'styled-components';

const ForgotContainer = styled(Paper)`
  padding: 40px;
  margin-top: 40px;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      const response = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!response.ok) {
        throw new Error('E-mail não encontrado');
      }
      setSuccess('Se o e-mail estiver cadastrado, você receberá as instruções para redefinir sua senha.');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Container>
      <ForgotContainer elevation={3}>
        <Typography variant="h5" component="h1" gutterBottom align="center">
          Recuperar Senha
        </Typography>
        <Typography variant="body1" align="center" sx={{ mb: 2 }}>
          Informe seu e-mail cadastrado para receber as instruções de recuperação de senha.
        </Typography>
        {success && <Alert severity="success">{success}</Alert>}
        {error && <Alert severity="error">{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <TextField
            label="E-mail"
            type="email"
            fullWidth
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button type="submit" variant="contained" color="primary" fullWidth>
            Enviar
          </Button>
        </Form>
        <Box mt={2} textAlign="center">
          <Link component="button" variant="body2" onClick={() => navigate('/login')}>
            Voltar para o login
          </Link>
        </Box>
      </ForgotContainer>
    </Container>
  );
};

export default ForgotPassword; 